import React from 'react';
export function Footer() {
  return <footer className="bg-dark text-white/50 py-8 text-center text-sm border-t border-white/10" data-id="element-151">
      <div className="max-w-7xl mx-auto px-4" data-id="element-152">
        <p data-id="element-153">© 2026 — Todos los derechos reservados.</p>
        <p className="mt-2 text-xs" data-id="element-154">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}